import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.prop.type === 'Boolean')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.value === 'true' || _ctx.value === true)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.prop.options && _ctx.prop.options["booleanTrueDisplayValue"]
            ? _ctx.prop.options["booleanTrueDisplayValue"]
            : _ctx.$t("yes")), 1)
              ], 64))
            : (_ctx.value === 'false' || _ctx.value === false)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.prop.options && _ctx.prop.options["booleanFalseDisplayValue"]
            ? _ctx.prop.options["booleanFalseDisplayValue"]
            : _ctx.$t("no")), 1)
                ], 64))
              : _createCommentVNode("", true)
        ], 64))
      : (['Options', 'Select', 'FreeSelect'].indexOf(_ctx.prop.type) >= 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.prop.options && _ctx.prop.options['valueDisplayType'] === 'icon')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (typeof _ctx.value === 'string' && _ctx.value.startsWith('glyphicon-'))
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass('glyphicon ' + _ctx.value)
                      }, null, 2))
                    : (typeof _ctx.value === 'string' && _ctx.value.startsWith('fa-'))
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 1,
                          class: _normalizeClass('fas ' + _ctx.value)
                        }, null, 2))
                      : (typeof _ctx.value === 'string' && _ctx.value.startsWith('fab-'))
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 2,
                            class: _normalizeClass('fab fa-' + _ctx.value.substring(4))
                          }, null, 2))
                        : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString((_ctx.prop.selectLabels && _ctx.prop.selectLabels[`${_ctx.value}`]) || _ctx.value), 1)
          ], 64))
        : (_ctx.prop.options && _ctx.prop.options['displayType'] === 'PASSWORD')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode("••••••••••••")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.value), 1)
            ], 64))
  ]))
}